import { render, staticRenderFns } from "./InviteReceiverMemberForm.vue?vue&type=template&id=6d6e2feb&"
import script from "./InviteReceiverMemberForm.vue?vue&type=script&lang=js&"
export * from "./InviteReceiverMemberForm.vue?vue&type=script&lang=js&"
import style0 from "./InviteReceiverMemberForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports